module.exports = __webpack_public_path__ + "img/P46-en.0be95c2a.png";